import api from './api';

export const musicService = {
  // Artists
  async getArtists() {
    const response = await api.get('/artists');
    return response.data;
  },

  async getArtist(id) {
    const response = await api.get(`/artists/${id}`);
    return response.data;
  },

  // Albums
  async getAlbums() {
    const response = await api.get('/albums');
    return response.data;
  },

  async getAlbum(id) {
    const response = await api.get(`/albums/${id}`);
    return response.data;
  },

  // Songs
  async getSongs() {
    const response = await api.get('/songs');
    return response.data;
  },

  async getSong(id) {
    const response = await api.get(`/songs/${id}`);
    return response.data;
  },

  // Playlists
  async getPlaylists() {
    const response = await api.get('/playlists');
    return response.data;
  },

  async getPlaylist(id) {
    const response = await api.get(`/playlists/${id}`);
    return response.data;
  },

  async getMyPlaylists() {
    const response = await api.get('/playlists/my-playlists');
    return response.data;
  },

  async createPlaylist(name, description, cover) {
    const response = await api.post('/playlists', { name, description, cover, is_public: true });
    return response.data;
  },

  async addSongToPlaylist(playlistId, songId) {
    const response = await api.post(`/playlists/${playlistId}/songs?song_id=${songId}`);
    return response.data;
  },

  // User favorites
  async getFavorites() {
    const response = await api.get('/user/favorites');
    return response.data;
  },

  async addToFavorites(type, itemId) {
    const response = await api.post(`/user/favorites/${type}/${itemId}`);
    return response.data;
  },

  async removeFromFavorites(type, itemId) {
    const response = await api.delete(`/user/favorites/${type}/${itemId}`);
    return response.data;
  },

  // Admin endpoints
  async createArtist(data) {
    const response = await api.post('/artists', data);
    return response.data;
  },

  async createAlbum(data) {
    const response = await api.post('/albums', data);
    return response.data;
  },

  async createSong(data) {
    const response = await api.post('/songs', data);
    return response.data;
  },

  async uploadAudio(file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/upload/audio', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  async uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/upload/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Delete methods
  async deleteArtist(artistId) {
    const response = await api.delete(`/artists/${artistId}`);
    return response.data;
  },

  async deleteAlbum(albumId) {
    const response = await api.delete(`/albums/${albumId}`);
    return response.data;
  },

  async deleteSong(songId) {
    const response = await api.delete(`/songs/${songId}`);
    return response.data;
  }
};
